//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Stars from './_stars'
import Line3 from './_line_3'
export default {
    props: {
        plate: {
            type: Object
        }
    },
    components: {
        Stars,
        Line3
    },
    data () {
        return {
        }
    },
    mounted () {
    },
    methods: {
        preview (url) {
            wx.previewImage({
                current: url,
                urls: [url]
            })
        }
    }
}
